export const SIDEBAR_WIDTH_ICON = '3rem';
